<script lang="ts">
  import { setContext } from 'svelte'
  import '../app.css'

  let { children, data } = $props()

  // svelte-ignore state_referenced_locally
  setContext('global', data)
</script>

<svelte:head>
  <title>Lutruvials | Software sob Medida para sua Empresa</title>

  {#if import.meta.env.PROD}
    <!-- Google Tag Manager -->
    <script async src="https://www.googletagmanager.com/gtag/js?id=AW-18063680452"></script>
    <script>
      window.dataLayer = window.dataLayer || []
      function gtag() {
        dataLayer.push(arguments)
      }
      gtag('js', new Date())
      gtag('config', 'AW-18063680452')
    </script>
    <!-- End Google Tag Manager -->
  {/if}

  {#if import.meta.env.PROD}
    <script src="https://code.jivosite.com/widget/17qwgIUpC7" async></script>
  {/if}
</svelte:head>

<div class="app">
  {@render children()}
</div>

{#if import.meta.env.PROD}
  <!-- Google Tag Manager (noscript) -->
  <!-- svelte-ignore a11y_missing_attribute -->
  <noscript
    ><iframe
      src="https://www.googletagmanager.com/ns.html?id=AW-18063680452"
      height="0"
      width="0"
      style="display:none;visibility:hidden"
    ></iframe></noscript
  >
  <!-- End Google Tag Manager (noscript) -->
{/if}
